'use client'

import { Pagination } from '@nextui-org/pagination'
import { useSearchParams, usePathname, useRouter } from 'next/navigation'

export default function ClientPagination({
    screen,
    totPages,
    currentPage,
}: Readonly<{ screen: string; totPages: number; currentPage: number }>) {
    const searchParams = useSearchParams()
    const pathname = usePathname()
    const { replace } = useRouter()

    function handleChange(page: number) {
        const params = new URLSearchParams(searchParams)
        params.set('page', page.toString())
        replace(`${pathname}?${params.toString()}`)
    }

    return (
        <>
            {screen === 'desktop' && (
                <Pagination
                    isCompact
                    showControls
                    size="lg"
                    total={totPages}
                    page={currentPage}
                    onChange={(page) => handleChange(page)}
                    classNames={{
                        base: 'border-black flex justify-between',
                        wrapper: 'bg-white border border-black',
                        item: 'w-8 h-8 text-lg bg-white lg:mx-1 md:mx-1',
                        cursor: 'bg-[#4FC2EB] text-black text-lg font-bold',
                        prev: 'border-black bg-white',
                        next: 'border-black bg-white',
                    }}
                />
            )}

            {screen === 'mobile' && (
                <div className="flex h-full w-full items-center justify-center border border-b-transparent border-l-transparent border-r-transparent border-t-black bg-white">
                    <Pagination
                        showControls
                        size="md"
                        total={totPages}
                        page={currentPage}
                        onChange={(page) => handleChange(page)}
                        classNames={{
                            base: 'flex justify-between',
                            wrapper: 'bg-white',
                            item: 'w-8 h-8 text-lg bg-white lg:mx-1 md:mx-1 shadow-none',
                            cursor: 'bg-[#4FC2EB] text-black text-lg font-bold',
                            prev: 'bg-white shadow-none',
                            next: 'bg-white shadow-none',
                        }}
                    />
                </div>
            )}
        </>
    )
}
